@let traductions = referentiel().metadonnees.traductions;

<form [formGroup]="form">
  <div class="gap-lg grid" formArrayName="familles">
    @for (form of familles.controls; track $index; let idx = $index) {
      <div [formGroupName]="idx" hlmField>
        <label [for]="'nom-' + idx" hlmFieldLabel labelRequired>Nom de la famille {{ idx + 1 }}</label>
        <input [id]="'nom-' + idx" hlmInput type="text" formControlName="nom" />
        @if (form.get('nom')?.hasError('required') && form.touched) {
          <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
        }
        @if (form.get('nom')?.hasError('notUnique')) {
          <hlm-field-error>Cette {{ traductions.familleDeLivrables.toLowerCase() }} existe déjà.</hlm-field-error>
        }
      </div>
    }
    <app-button-add-new (click)="addFamille()" label="Ajouter une autre famille de livrables" />
  </div>
</form>
